module.exports = __webpack_public_path__ + "static/media/github.dcf16ddd.png";